export default "__VITE_ASSET__BWTF_NGL__"